export const Shadows = (value: number) => (srcData: any) => {
  const shadows = value / 100; // normalize to -1 to 1
  const data = srcData.data;
  const len = data.length;

  for (let i = 0; i < len; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];

    // Calculate luminance to determine if pixel is in shadows
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    // Only affect pixels with low luminance (shadows)
    const shadowMask = Math.max(0, (128 - luminance) / 128); // 1-0 for pixels below middle gray

    // Apply adjustment only to shadows
    const adjustment = shadows * shadowMask;
    const factor = 1 + adjustment;

    data[i] = Math.min(255, Math.max(0, r * factor));
    data[i + 1] = Math.min(255, Math.max(0, g * factor));
    data[i + 2] = Math.min(255, Math.max(0, b * factor));
  }
};
